import { contactsApi } from './contactsApi';
import { gemApi } from './gemApi';
import { websitesApi } from './websitesApi';
import { productGraphApi } from './productGraphApi';
import { websiteAccountApi } from './websitesAccountApi';

export const endpoints = [gemApi, contactsApi, websitesApi, productGraphApi, websiteAccountApi];
